import I18n from "../../../../commons/I18n/I18n";
import ScreenCard from "../../../../components/screen/ScreenCard";
import { AppIcon } from "../../../../config/Config";
import I18nKeys from "../../../../I18n/I18nKeys";
import { ROUTE_COMPANY_USER_RATIFICATION_REPORTS } from "../../../../routing/Routes";
import RatificationReportListCompanyUserCard from "./RatificationReportListCompanyUserCard";

const RatificationReportListCompanyUserScreen = () => (
  <ScreenCard breadcrumbs={[
    {
      name: I18n.tr(I18nKeys.ADVERACION),
      url: ROUTE_COMPANY_USER_RATIFICATION_REPORTS,
      icon: AppIcon.REPORT,
    },
  ]}>
    <RatificationReportListCompanyUserCard/>
  </ScreenCard>
);
  
export default RatificationReportListCompanyUserScreen;
